module.exports = {
    "10210030": {lat: '30.935794909760332', lng: '103.94520166403198'},
    "10210040": {lat: '30.974424115008773', lng: '103.94219383068851'},
    "10210050": {lat: '30.936234', lng: '103.941795'},
    "10210060": {lat: '30.95042', lng: '104.11891'},
    "10210070": {lat: '30.982641', lng: '103.932129'},
    "10210080": {lat: '30.98878120', lng: '104.02595293'},
    "10210090": {lat: '30.98839', lng: '103.976608'},
    "10210100": {lat: '30.98496529', lng: '103.94395744'},
    "10210110": {lat: '31.090353', lng: '103.984066'},
    "10210120": {lat: '30.99641826', lng: '103.03876478'},
    "10210130": {lat: '30.97898000', lng: '103.88613600'},
    "10210140": {lat: '31.16806900', lng: '103.88613600'},
    "10210150": {lat: '31.16806900', lng: '103.8380600'},
    "10210160": {lat: '31.02460400', lng: '103.95617200'},
    "10210170": {lat: '30.99455800', lng: '103.94005600'},
    "10210180": {lat: '31.02853000', lng: '104.11352700'},
    "10210190": {lat: '31.03247500', lng: '104.02704500'},
    "10210200": {lat: '31.04962300', lng: '103.98246900'},
    "10210210": {lat: '31.09589100', lng: '103.94414500'},
    "10210220": {lat: '31.04013100', lng: '103.79426200'},
    "10210230": {lat: '31.07187800', lng: '103.86191500'},
    "10210240": {lat: '31.11090900', lng: '103.78953000'},
    "10210250": {lat: '31.150008000', lng: '104.01030600'},
    "10210260": {lat: '31.23645800', lng: '103.79346900'},
    "10210270": {lat: '31.21011700', lng: '103.92022000'},
    "10210280": {lat: '31.14776500', lng: '103.85111500'},
    "10210290": {lat: '30.96284700', lng: '103.96449400'},
    "10210300": {lat: '31.19689300', lng: '103.76609000'},
    "10210310": {lat: '30.93678', lng: '104.12474'},
    "10210031": {lat: '30.988854490564382', lng: '103.93770530555724'},
    "10210032": {lat: '31.02605600', lng: '103.95257900'},
}



// WEBPACK FOOTER //
// ./src/config/dict/map.js